// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout';
var financeRouter = {
  path: "/finance",
  name: 'finance',
  meta: {
    icon: '',
    title: '财务'
  },
  alwaysShow: true,
  redirect: '/finance/capitalFlow',
  component: Layout,
  children: [{
    path: 'statement',
    name: 'FinanceStatement',
    meta: {
      title: '账单管理',
      noCache: true
    },
    component: function component() {
      return import('@/views/finance/statement/index');
    }
  }, {
    path: 'capitalFlow',
    name: 'FinanceCapitalFlow',
    meta: {
      title: '资金流水',
      noCache: true
    },
    component: function component() {
      return import('@/views/finance/capitalFlow/index');
    }
  }, {
    path: 'closingRecord',
    name: 'FinanceClosingRecord',
    meta: {
      title: '结算记录 ',
      noCache: true
    },
    component: function component() {
      return import('@/views/finance/closingRecord/index');
    }
  }, {
    path: 'profit_sharing',
    component: function component() {
      return import('@/views/finance/profit_sharing/index');
    },
    name: 'ProfitSharing',
    meta: {
      title: '分账记录',
      icon: ''
    }
  }, {
    path: 'lakala',
    component: function component() {
      return import('@/views/finance/lakala/index');
    },
    name: 'FinanceLakala',
    meta: {
      title: '开通分账',
      icon: ''
    }
  }, {
    path: 'qrcode',
    component: function component() {
      return import('@/views/finance/qrcode/index');
    },
    name: 'FinanceQrcode',
    meta: {
      title: '线下收款管理',
      icon: ''
    }
  }, {
    path: 'payment',
    component: function component() {
      return import('@/views/finance/payment/index');
    },
    name: 'FinancePayment',
    meta: {
      title: '支付单管理',
      icon: ''
    }
  }, {
    path: 'dashboard',
    component: function component() {
      return import('@/views/dashboard/offline/index');
    },
    name: 'OfflineDashboard',
    meta: {
      title: '线下订单驾驶舱',
      icon: ''
    }
  }]
};
export default financeRouter;